<template>
  <div class="w-full">
    <div
      class="model flex items-center w-full"
      @click="openDetail"
    >
      <input
        v-model="value"
        type="text"
        class="inputt w-full h-full pb-6"
        :placeholder="placeholder"
      >
    </div>

    <divider
      class=""
      height="1px"
      color="#5F01D3"
    />
    {{ sendValue }}
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Civilité'
    },
    diviserHeight: {
      type: String,
      default: '1px'
    },
    diviserColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.2)'
    }
  },
  data () {
    return {
      activeDetail: false,
      selectedItem: null
    }
  },
  computed: {
    sendValue: function () {
      this.$emit('info', this.value)
    }
  },
  methods: {
    startWrite () {
      this.value = ''
    },
    openDetail () {
      this.activeDetail = !this.activeDetail
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";

.model{
  font-weight: 600;
  font-size: 14.1603px;
  line-height: 17px;
  color: $form-text;
}

.inputt{
  font-weight: 600;
  font-size: 14.1603px;
  line-height: 17px;
  color: $form-text;
}
</style>
